import React from 'react';
import clsx from 'clsx';
import useStyles from './TextBlock.styles';

export type ITextType =
  | 'consoleHeaderTB'
  | 'pageHeaderTB'
  | 'userNameTB'
  | 'titleConfirmModalTB'
  | 'titleErrorModalTB'
  | 'textConfirmModalTB'
  | 'textErrorModalTB'
  | 'alignCenterTB'
  | 'fileUploadModalTB'
  | 'fileUploadTitleModalTB';

interface ITextBlockProps {
  type: ITextType;
  text?: string;
  alignCenter?: boolean;
  leftFloat?: boolean;
}

export const TextBlock: React.FC<ITextBlockProps> = ({
  type,
  text,
  alignCenter = false,
  leftFloat = false,
}) => {
  const classes = useStyles();
  const contentClasses = clsx({
    [classes[type]]: true,
    [classes.fontRoboto]: true,
    [classes.alignCenterTB]: alignCenter,
    [classes.leftFloat]: leftFloat,
  });

  return (
    <p className={contentClasses} data-qa-name={type}>
      {text}
    </p>
  );
};
